// GameStateContext.js
import React, { createContext, useContext, useState } from 'react';

const GameStateContext = createContext();

export function useGameState() {
  return useContext(GameStateContext);
}

export const GameStateProvider = ({ children }) => {
  const [gameState, setGameState] = useState({
    score: 0,
    level: 1,
    isGameOver: false
  });

  // Function to modify the game state
  const updateScore = (newScore) => {
    setGameState(prevState => ({
      ...prevState,
      score: newScore
    }));
  };

  return (
    <GameStateContext.Provider value={{ gameState, updateScore }}>
      {children}
    </GameStateContext.Provider>
  );
};